/**
 * Masonry Layout
 *
 * Custom two-column masonry layout for .masonry-container elements.
 * Extracted from global.js to load only on pages that use masonry.
 */

function createMasonryLayout(containerId) {
  const container = document.querySelector('.' + containerId);
  if (!container) return;

  if (window.innerWidth <= 749) {
    const items = Array.from(container.children);
    container.innerHTML = ''; // Clear current layout
    items.forEach((item) => container.appendChild(item)); // Restore all items directly into the container
    return;
  }

  const items = Array.from(container.children);

  // Step 1: Calculate dimensions of items while they are still in the DOM
  const itemData = items.map((item) => {
    const styles = window.getComputedStyle(item);
    const aspectRatio = styles.getPropertyValue('aspect-ratio') || '1/1'; // Default to square if not set
    const [widthRatio, heightRatio] = aspectRatio.split('/').map(Number);
    const width = item.getBoundingClientRect().width; // Get current width
    const height = width * (heightRatio / widthRatio); // Calculate height based on aspect ratio
    return { item, height };
  });

  // Step 2: Clear the container and create two columns
  container.innerHTML = '';
  const column1 = document.createElement('div');
  const column2 = document.createElement('div');
  column1.className = 'masonry-column';
  column2.className = 'masonry-column';

  let column1Height = 0;
  let column2Height = 0;

  // Step 3: Distribute items into columns
  itemData.forEach(({ item, height }) => {
    if (column1Height <= column2Height) {
      column1.appendChild(item);
      column1Height += height;
    } else {
      column2.appendChild(item);
      column2Height += height;
    }
  });

  // Step 4: Append columns to the container
  container.appendChild(column1);
  container.appendChild(column2);
}

// Initialize masonry layout only when a container exists on the page
if (document.querySelector('.masonry-container')) {
  createMasonryLayout('masonry-container');

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      createMasonryLayout('masonry-container');
    }, 200);
  });
}
